import { getEnvironmentDetector } from './environmentDetector';

// Get the CSInterface from the window object
const getCsInterface = () => {
  return (window as any).csInterface;
};

// Server port mapping for each environment
const SERVER_PORT_MAP: Record<'master' | 'dev' | 'local', number> = {
  master: 24802,
  dev: 24803,
  local: 24804
};

// WebSocket port mapping for each environment
const WEBSOCKET_PORT_MAP: Record<'master' | 'dev' | 'local', number> = {
  master: 8080,
  dev: 8081,
  local: 8082
};

/**
 * Get the server URL for the current environment
 */
export function getServerUrl(endpoint: string = ''): string {
  try {
    const csInterface = getCsInterface();
    if (!csInterface) {
      console.warn('CSInterface not available, falling back to default server port');
      return `http://localhost:24802/${endpoint}`;
    }

    const envDetector = getEnvironmentDetector(csInterface);
    const environment = envDetector.getEnvironment();
    
    // Use the server port mapping instead of the After Effects port
    const serverPort = SERVER_PORT_MAP[environment];
    const url = `http://localhost:${serverPort}/${endpoint}`;
    
    console.log(`Server URL for ${environment} environment: ${url} (port: ${serverPort})`);
    return url;
  } catch (error) {
    console.error('Error getting server URL:', error);
    return `http://localhost:24802/${endpoint}`;
  }
}

/**
 * Get the WebSocket URL for the current environment
 */
export function getWebSocketUrl(): string {
  try {
    const csInterface = getCsInterface();
    if (!csInterface) {
      console.warn('CSInterface not available, falling back to default WebSocket port');
      return 'ws://localhost:8080';
    }

    const envDetector = getEnvironmentDetector(csInterface);
    const environment = envDetector.getEnvironment();
    
    // Use the WebSocket port mapping instead of the After Effects debug port
    const wsPort = WEBSOCKET_PORT_MAP[environment];
    const url = `ws://localhost:${wsPort}`;
    
    console.log(`WebSocket URL for ${environment} environment: ${url} (port: ${wsPort})`);
    return url;
  } catch (error) {
    console.error('Error getting WebSocket URL:', error);
    return 'ws://localhost:8080';
  }
}
